import { useEffect, useState } from "react";

export default function ChatSettingsWidget() {
  const [config, setConfig] = useState({ enabled: true });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/chat_admin.php?action=status", { credentials: "same-origin" });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || "Unable to load chat setting");
      setConfig(data.config || { enabled: true });
    } catch (err) {
      setMessage(err.message || "Unable to load chat setting");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch("/api/chat_admin.php?action=save", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "save", enabled: !!config.enabled }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || "Save failed");
      setConfig(data.config || { enabled: true });
      setMessage(data.config?.enabled ? "Chat enabled." : "Chat disabled.");
    } catch (err) {
      setMessage(err.message || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white text-gray-900 rounded-2xl shadow p-6 w-full">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-5">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Appointment Chat</h2>
          <p className="text-sm text-gray-600 mt-1">Enable or disable the Mautic appointment chat on the public site without removing the code.</p>
        </div>
        <div className={`text-sm rounded-xl px-4 py-3 border ${config.enabled ? "bg-green-50 border-green-200 text-green-900" : "bg-gray-50 border-gray-200 text-gray-700"}`}>
          <div className="font-semibold">Status</div>
          <div>{config.enabled ? "Enabled" : "Disabled"}</div>
        </div>
      </div>
      {message && <div className="mb-4 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900">{message}</div>}
      <form onSubmit={save} className="space-y-4">
        <label className="flex items-center gap-2 text-sm font-medium">
          <input type="checkbox" checked={!!config.enabled} onChange={(e) => setConfig({ ...config, enabled: e.target.checked })} />
          Enable appointment chat
        </label>
        <div className="flex gap-2">
          <button disabled={loading} className="bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white px-4 py-2 rounded-lg" type="submit">
            Save Chat Setting
          </button>
          <button disabled={loading} className="border px-4 py-2 rounded-lg disabled:opacity-60" type="button" onClick={load}>
            Refresh
          </button>
        </div>
      </form>
    </div>
  );
}
